import { React } from 'react';
import styled from 'styled-components';

export default function NewLessonNameInput(props) {
	const { value, setValue, placeholder, isClassEng=false, isLeft=false } = props;

	function handleChange(e) {
		setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

	return (
    <TopLevelWrapper>
      <Input
        type='text'
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        isClassEng={isClassEng}
        isLeft={isLeft} />
    </TopLevelWrapper>
  ) 
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;
	
	padding: 0 8px 0 8px;

  box-sizing: border-box;
  width: ${props => props.isClassEng ? '54px' : '100%'};
  height: 32px;

  text-align: ${props => props.isLeft ? 'left' : props.isClassEng ? 'center' : 'right'};

	outline: none;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

	color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.line};
  }
	
  transition: all 0.5s ease-in-out;
`;
